export default "__VITE_ASSET__042e12f8__$_?nuxt_component=async&nuxt_component_name=SvgoWhatsapp__"